export const PAYMENT_STRINGS = {
  success: {
    title: '¡Pago realizado correctamente!',
    description: 'Los tests han sido agregados a tu cuenta.',
    paidSubtitle: 'Pagado exitosamente',
    backButton: 'Volver al cliente',
    detailsTitle: 'Detalles del pago',
    planLabel: 'Plan',
    testsLabel: 'Tests agregados',
    dateLabel: 'Fecha',
    amountLabel: 'Monto',
    statusLabel: 'Estado',
    statusSuccess: 'Exitoso',
  },
  failure: {
    title: 'El pago no pudo ser procesado',
    description: 'Hubo un problema al procesar tu pago. Por favor, intenta nuevamente.',
    backButton: 'Volver al cliente',
    retryButton: 'Reintentar compra',
  },
  successGuest: {
    title: '¡Pago recibido!',
    description: 'Recibimos tu pago correctamente. Tu plan quedará activo una vez que completemos el proceso de enrolamiento de tu empresa. Te contactaremos para finalizar la activación.',
    contactPrefix: 'Si tienes cualquier duda, ',
    contactLinkLabel: 'contáctanos',
  },
  failureGuest: {
    title: 'El pago no pudo ser procesado',
    description: 'Hubo un problema al procesar tu pago. Puedes intentar nuevamente.',
    retryButton: 'Volver a intentar',
  },
};
